<div class="delete-confirmation">
    <div>
        <div class="confirmation-line1"><h4>Are you sure you would like to delete this photo ?</h4></div>
        <div class="confirmation-line2">Note: This will also be permanently removed from the inspection report and any recommendations that use it.</div>
    </div>
    
    <div class="button-container">
        <a class="button button-no" (click)="onCloseClick()">
            <span class="button__text">No</span>
        </a>
        <a class="button button--primary button-yes" (click)="onConfirmDeleteClick()">
            <span class="button__text">Yes</span>
        </a>
    </div>
</div>
